module.exports = __webpack_public_path__ + "img/lv8.59afb1a0.png";